(function () {
  'use strict';

  if (window.TestGuard) return;

  var RETURN_KEY = 'test_guard_return';
  var LOGIN_URL = '/customer_authentication/login';

  function startLogin(returnTo) {
    var path = returnTo || window.location.pathname + window.location.search + window.location.hash;

    try {
      sessionStorage.setItem(RETURN_KEY, path);
    } catch (error) {}

    window.location.href = LOGIN_URL;
  }

  function bindLoginTriggers(root) {
    (root || document).querySelectorAll('[data-test-guard-login]').forEach(function (trigger) {
      if (trigger.dataset.testGuardBound === '1') return;
      trigger.dataset.testGuardBound = '1';

      trigger.addEventListener('click', function () {
        startLogin(trigger.dataset.returnTo);
      });
    });
  }

  function observeDynamicTriggers() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-test-guard-login]')) {
            bindLoginTriggers(node.parentElement || document);
          } else if (node.querySelector && node.querySelector('[data-test-guard-login]')) {
            bindLoginTriggers(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    bindLoginTriggers(document);
    observeDynamicTriggers();
  }

  window.TestGuard = {
    startLogin: startLogin,
    bindLoginTriggers: bindLoginTriggers,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
